export default __webpack_public_path__ + "static/media/BrutalType-Regular.bb2b4b39.woff";